import React, { useState } from 'react';

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  }

const Contact = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');

    const handleChange = e => {
        if(e.target.name === 'name'){
            setName(e.target.value);
        }
        if(e.target.name === 'email'){
            setEmail(e.target.value);
        }
        if(e.target.name === 'message'){
            setMessage(e.target.value);
        }
    }


    const onSubmit = e => {
        e.preventDefault();

        const data = { "form-name": "contact-shiftmindset", name, email, message};

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode(data)
            })
            .then(() => setStatus('Thank you!'))
            .catch(error => setStatus('Error'));
        
        setName('');
        setEmail('');
        setMessage('');
    }



    return (
        <div>
            <div className="jumbotron">
                <div className="container">
                    <h1 className="display-4">Contact</h1>
                    <p className="lead">Contact us to for your questions, concerns and inquiries for the Shift Mindset Book.</p>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div  className="col-lg center-hori">
                        <i style={{fontSize: '5em'}} className="fas fa-phone text-danger"></i>
                        <a className="text-dark" href='tel:647-969-7274'><h4 className='center-xs'>(647) 969 7274</h4></a>
                    </div>
                    <div  className="col-lg center-hori">
                        <i style={{fontSize: '5em'}} className="fas fa-envelope text-danger"></i>
                        <h4 className='center-xs'>anish@emaginetalks.com</h4>
                    </div>
                    <div className="col-lg center-hori">
                    <i style={{fontSize: '5em'}} className="fas fa-map-marker-alt text-danger"></i>
                    <h4 className='center-xs'>Toronto, Ontario</h4>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="center-xs">
                    <h1>Have Questions? Ask Us.</h1>
                    <p className="text-muted">We'll get back to you within 24 hours</p>
                </div>
                <form name='contact-shiftmindset' method="post" data-netlify="true" onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md">
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input type="text" className="form-control" id="name" name="name" value={name} onChange={handleChange}/>
                            </div>
                        </div>
                        <div className="col-md">
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" className="form-control" id="email" name="email" value={email} onChange={handleChange}/>
                                <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea className="form-control" id="message" rows="3" name="message" value={message} onChange={handleChange}></textarea>
                    </div>
                    <p>{status}</p>
                    <div style={{textAlign: 'right'}}>
                        <button  type="submit" className="btn btn-danger">Submit</button>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default Contact
